var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelemetry = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 12.1956C32.5 12.6526 32.0938 13.0081 31.6875 13.0081H24.8828L21.8359 20.6252C21.7344 20.9807 21.4297 21.1838 21.0234 21.1331C20.7188 21.1331 20.4141 20.8792 20.3125 20.5237L16.3008 4.52759L12.1367 25.3987C12.0859 25.7542 11.7305 26.0081 11.375 26.0081C10.9688 26.0081 10.6641 25.7542 10.5625 25.3987L7.46484 13.0081H0.8125C0.355469 13.0081 0 12.6526 0 12.1956C0 11.7893 0.355469 11.4338 0.8125 11.4338H8.125C8.48047 11.4338 8.78516 11.6877 8.88672 12.094L11.2734 21.5901L15.4375 0.718994C15.4883 0.312744 15.8438 0.0588379 16.1992 0.00805664C16.6055 0.0588379 16.9102 0.261963 17.0117 0.668213L21.2773 17.7307L23.6133 11.9417C23.7148 11.5862 24.0195 11.3831 24.375 11.3831H31.6875C32.0938 11.3831 32.5 11.7893 32.5 12.1956Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelemetry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telemetry.bc4cadbba9510a195da4a9602e3e0839.svg";